import { render, staticRenderFns } from "./rightBar.vue?vue&type=template&id=ffbf1d72&scoped=true"
import script from "./rightBar.vue?vue&type=script&lang=js"
export * from "./rightBar.vue?vue&type=script&lang=js"
import style0 from "./rightBar.vue?vue&type=style&index=0&id=ffbf1d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbf1d72",
  null
  
)

export default component.exports